// Vite'ta environment variable'lar import.meta.env'den okunur
const devFallback = 'http://localhost:5001';

/**
 * Socket, yüklenen dosya URL'leri vb.: doğrudan Railway/backend host'u (build-time env).
 */
export const DIRECT_BACKEND_URL =
  import.meta.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL || devFallback;

/**
 * Axios REST çağrıları: production'da boş = aynı origin (/api → Vercel rewrite → Railway).
 * Böylece httpOnly çerezler birinci taraf olur (Safari / ITP ile uyumlu).
 */
export const HTTP_API_BASE_URL = import.meta.env.PROD ? '' : DIRECT_BACKEND_URL;

/** @deprecated HTTP_API_BASE_URL kullanın */
export const API_BASE_URL = HTTP_API_BASE_URL;